import { Card, Typography } from '@mui/material';
import ColorChartThumbnail from '../components/charts/ColorChartThumbnail';

const MotifCard = ({ motif, colors, onClick }) => {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        p: 2,
        cursor: 'pointer',
        '&:hover': { boxShadow: 1 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'background.paper'
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        {motif.name}
      </Typography>
      {motif.data && <ColorChartThumbnail data={motif.data} colors={colors} mincols={24} norepeat={motif.norepeat} settings={motif.settings} />}
      {motif.keywords && (
        <Typography variant="body2" color="text.secondary">
          {motif.keywords}
        </Typography>
      )}
    </Card>
  );
};

export default MotifCard;
